import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import TooltipWrapper from 'components/Tooltip';
import {PermissionResponse} from 'types/permissions';

export type NavigationTabsTeamButtonPermissions = {
    groupsAndRoles: PermissionResponse;
    members: PermissionResponse;
    revoked: PermissionResponse;
};

type NavigationTabsTeamProps = NavigationTabsPropsHelper &
    NavigationTabsTeamButtonPermissions;

const NavigationTabsTeam: FC<NavigationTabsTeamProps> = ({
    className,
    groupsAndRoles,
    members,
    revoked,
    selection,
}) => {
    const {t} = useTranslation('Navigation.NavigationTabs');

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            <TooltipWrapper message={members.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!members.allowed}
                    href="/home/team/"
                    label={t('team.members')}
                    name="members"
                />
            </TooltipWrapper>
            <TooltipWrapper message={groupsAndRoles.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!groupsAndRoles.allowed}
                    href="/access-control/team/"
                    label={t('team.groupsAndRoles')}
                    name="groupsAndRoles"
                />
            </TooltipWrapper>
            <TooltipWrapper message={revoked.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!revoked.allowed}
                    href="/access-control/team/revoked/"
                    label={t('team.revoked')}
                    name="revoked"
                />
            </TooltipWrapper>
        </BaseNavigationTabs>
    );
};

export default NavigationTabsTeam;
